import React from 'react';
import './ModernContainer.css';

/**
 * Modern Container Component
 * Provides consistent layout structure
 */
const ModernContainer = ({ children, maxWidth = '1400px', className = '' }) => {
  return (
    <div className={`modern-container ${className}`} style={{ maxWidth }}>
      {children}
    </div>
  );
};

export default ModernContainer;
